import React from 'react';
import displayName from 'component-lib/displayName';
import styles from './Forms.scss';

export default function FormRowDivider() {
    return (
        <div className={styles['form-row-divider']} />
    );
}

FormRowDivider.displayName = displayName('Forms/FormDivider');

